import http from "plugins/axios";

export default {
  // 头像昵称审核列表
  getLeaderAuditList(data) {
    return http.get({
      url: "/ta/admin/tenant/siteProfileAudit/list",
      data,
    });
  },
  // 头像昵称审核
  getLeaderProfileAudit(data) {
    return http.post({
      url: "/ta/admin/tenant/siteProfileAudit/audit",
      data,
    });
  },
  // 头像昵称审核记录
  getLeaderProfileAuditRecord(data) {
    return http.get({
      url: "/ta/admin/tenant/siteProfileAudit/records",
      data,
    });
  },
};
